<template>
    <CodiceFeanorView tool-module="yescrypt" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
